var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"cause-select",on:{"change":_vm.handleChange},model:{value:(_vm.cause),callback:function ($$v) {_vm.cause=$$v},expression:"cause"}},_vm._l((_vm.guestCauseOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }